/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { Button, ButtonToolbar } from "react-bootstrap";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openReceiptDialog,openEditStatusDialog }
) => (
  <>
    <ButtonToolbar className="view-download-btn justify-content-end">
      <Button
        variant="btn btn-icon btn-light-success btn-sm mx-1 font-size-sm "
        onClick={() => {
          openReceiptDialog(row);
        }}
      >
        <i className="fa fa-eye" />
      </Button>
      <Button
        variant="btn btn-icon btn-light-primary btn-sm mx-1 font-size-sm"
        onClick={() => {
          openEditStatusDialog(row);
        }}
      >
        <i className="fa fa-edit" />
      </Button>
    </ButtonToolbar>
    <> </>
  </>
);
